import { ProductCategory, ProductListItemDTO } from '@iota/inh-core-v1-management-client';
import { CompanyProductSelectionWithProduct } from 'src/app/store/entity-models';
import { isDiscontinued } from '../../utils';

export interface ActiveSelectionCategories {
    categories: ProductCategory[];
    /** An active selection whose product is not in the list has an unknown category. */
    hasUnresolvedProduct: boolean;
}

export function collectActiveCategories(selections: CompanyProductSelectionWithProduct[]): ActiveSelectionCategories {
    const activeSelections = selections.filter((selection) => !isDiscontinued(selection));

    return {
        categories: activeSelections.map((selection) => selection.product?.productCategory).filter((category) => !!category),
        hasUnresolvedProduct: activeSelections.some((selection) => !selection.product?.productCategory)
    };
}

/** A category may be used by at most one active selection, so an unknown one cannot be accepted either. */
export function isValidSelection(selectedProducts: ProductListItemDTO[], activeCategories: ActiveSelectionCategories): boolean {
    if (activeCategories.hasUnresolvedProduct) {
        return false;
    }

    const selectedCategories = selectedProducts.map((product) => product.productCategory);
    if (new Set(selectedCategories).size !== selectedCategories.length) {
        return false;
    }

    return !selectedCategories.some((category) => activeCategories.categories.includes(category));
}
